import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eaaa2d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_use_svg = _resolveComponent("use-svg")!

  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createVNode(_component_use_svg, {
      class: "svg",
      svg: "calendar"
    }),
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addToCalendar && _ctx.addToCalendar(...args)))
    }, _toDisplayString(_ctx.translate('shared.addToCalendar')), 1)
  ]))
}